<template>
  <div>
    <preloader v-if="showPreloader"></preloader>
    <camera v-if="showCamera"
      :imagesList="photoType"
      v-on:closecamera="closeCamera">
    </camera>
    <signatures v-if="showSignature"
      :signaturesList="photoType"
      v-on:closesignature="closeSignature">
    </signatures>
    <b-alert
      :show="dismissCountDown"
      dismissible
      fade
      variant="primary"
      @dismissed="dismissCountDown=0"
      @dismiss-count-down="countDownChanged"
      >
        {{allertMessage}}
    </b-alert>
    <div class="container">
      <h1 class="text-center sm">
        <base-button @click="goToJobs(true)" size="md" class="back-button mt-1" type="primary" >Back</base-button>
        Job Action
      </h1>
      <div v-if="jobAction === 1" class="card card-profile shadow mb-3">
        <standServiceForm
          :disableSubmitButton="disableButton"
          @standServiceFormDataSend="standServiceSendData"></standServiceForm>
      </div>
      <div v-if="jobAction === 2" class="card card-profile shadow mb-3">
        <eboardServiceForm
          :disableSubmitButton="disableButton"
          @eboardServiceFormDataSend="eboardServiceSendData"></eboardServiceForm>
      </div>
      <div v-if="jobAction === 8" class="card card-profile shadow mb-3">
        <digitalHeaderServiceForm
          :disableSubmitButton="disableButton"
          @digitalHeaderServiceFormDataSend="digitalHeaderServiceSendData"></digitalHeaderServiceForm>
      </div>
      <div v-if="jobAction === 3" class="card card-profile shadow mb-3">
        <tabletServiceForm
          :disableSubmitButton="disableButton"
          @tabletServiceFormDataSend="tabletServiceSendData"></tabletServiceForm>
      </div>
      <div v-if="jobAction === 4" class="card card-profile shadow mb-3">
        <deliveryForm
          :disableSubmitButton="disableButton"
          @deliveryInfoFormDataSend="deliveryInfoSendData"></deliveryForm>
      </div>
      <div v-if="jobAction === 5" class="card card-profile shadow mb-3">
        <standInfoForm
          :disableSubmitButton="disableButton"
          @standInfoFormDataSend="standInfoSendData"></standInfoForm>
      </div>
      <div v-if="jobAction === 7" class="card card-profile shadow mb-3">
        <piratesForm
          :disableSubmitButton="disableButton"></piratesForm>
      </div>
    </div>
  </div>
</template>

<script>
import alertMixin from './../mixins/alertMixin'
import standsMixin from './../mixins/standsMixin'
import jobsMixin from './../mixins/jobsMixin'
import timestampMixin from './../mixins/timestampMixin'
import camera from './../../components/Camera'
import signatures from './../../components/Signatures'
import jobActionsMixin from './../mixins/jobActionsMixin'
import jobActionFormMixin from './../mixins/jobActionFormMixin'
import standServiceForm from './../../components/StandServiceForm'
import eboardServiceForm from './../../components/EboardServiceForm'
import digitalHeaderServiceForm from './../../components/DigitalHeaderServiceForm'
import deliveryForm from './../../components/DeliveryForm'
import tabletServiceForm from './../../components/TabletServiceForm'
import standInfoForm from './../../components/StandInfoForm'
import piratesForm from './../../components/PiratesForm'

export default {
  data () {
    return {
      showPreloader: false,
      showCamera: null,
      showSignature: false,
      images: [],
      signatures: [],
      photoType: null,
      jobAction: null
    }
  },
  mounted () {
    this.checkJobAction()
  },
  computed: {
    token () {
      return this.$store.state.user.token
    }
  },
  methods: {
    checkJobAction () {
      this.jobAction = +this.$route.params.action
      if ([1, 2, 3, 4, 5, 7, 8].indexOf(this.jobAction) < 0) {
        this.$router.push('/jobActions')
      }
    },
    checkStandClassAndRedirect () {
      let stand = this.activeStand
      let standClass = stand.class
      let jobActionFormId = this.getJobActionFormId(standClass)
      if (!jobActionFormId) {
        this.$router.push('/jobactions')
      } else {
        this.endJobActions()
        this.goBack()
      }
    }
  },
  mixins: [alertMixin, standsMixin, jobsMixin, jobActionsMixin, timestampMixin, jobActionFormMixin],
  components: {
    camera,
    signatures,
    standServiceForm,
    eboardServiceForm,
    digitalHeaderServiceForm,
    deliveryForm,
    tabletServiceForm,
    standInfoForm,
    piratesForm
  }
}
</script>
<style lang="css">
  .link {
    cursor: pointer;
  }
  .overflowbody {
    height: 100vh;
    overflow: hidden;
  }
</style>
